
class PackageItem {

    public id: string;
    public name: string;
    public amount: number;
    public comments: string;

    public itemPrice: number;
    public finalItemPrice: number;
    public weight: number;
    public group: number | null;

    constructor(id: string, name: string, amount: number, comments: string, itemPrice: number, finalItemPrice: number, weight:number, group: number|null) {
        this.id = id;
        this.name = name;
        this.amount = amount;
        this.comments = comments;

        this.itemPrice = itemPrice;
        this.finalItemPrice = finalItemPrice;
        this.weight = weight;
        this.group = group;
    }
}
export default PackageItem